import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Layout, Spin } from "antd";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { getUser, logout } from "../slices/authSlice";
import HeaderBar from "./components/HeaderBar";
import Sidebar from "./components/Sidebar";
import AppFooter from "./components/AppFooter";
import { useIsMobile } from "../hooks/useIsMobile";

const { Content } = Layout;
const SIDEBAR_WIDTH = 200;

const ProtectedLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const basicUserInfo = useAppSelector((s) => s.auth.basicUserInfo);
  const userProfileInfo = useAppSelector((s) => s.auth.userProfileData);
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    if (basicUserInfo) dispatch(getUser(basicUserInfo.id));
  }, [basicUserInfo, dispatch]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const fullName = `${userProfileInfo?.firstName || ""} ${userProfileInfo?.lastName || ""}`;
  const azureImageUrl = userProfileInfo?.photoUrl || "";

  if (basicUserInfo && !userProfileInfo) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Spin size="large" />
      </Box>
    );
  }

  const mainMarginLeft = isMobile ? 0 : collapsed ? 80 + 32 : SIDEBAR_WIDTH + 32;
  const headerHeight = isMobile ? 56 : 72;
  const headerTop = isMobile ? 8 : 16;
  const footerHeight = isMobile ? 48 : 60;
  const footerBottom = isMobile ? 8 : 16;
  const contentPadX = isMobile ? 12 : 32;
  const contentGap = isMobile ? 8 : 8;

  return (
    <Layout>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        SIDEBAR_WIDTH={SIDEBAR_WIDTH}
      />

      <Layout
        style={{
          marginLeft: mainMarginLeft,
          minHeight: "100vh",
          transition: "all 0.3s ease",
        }}
      >
        <HeaderBar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          fullName={fullName}
          azureImageUrl={azureImageUrl}
          imageError={imageError}
          setImageError={setImageError}
          handleLogout={handleLogout}
          SIDEBAR_WIDTH={SIDEBAR_WIDTH}
        />
        <Content
          style={{
            marginTop: headerTop + headerHeight + contentGap,
            marginBottom: footerBottom + footerHeight + contentGap,
            padding: `0px ${contentPadX}px`,
            height: `calc(100vh - ${headerTop + headerHeight + footerBottom + footerHeight + contentGap * 2}px)`,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            transition: "all 0.3s ease",
          }}
        >
          <Outlet />
        </Content>
        <AppFooter
          collapsed={collapsed}
          SIDEBAR_WIDTH={SIDEBAR_WIDTH}
        />
      </Layout>
    </Layout>
  );
};

export default ProtectedLayout;
